import dynamic from 'next/dynamic';
import {createTranslator, type AbstractIntlMessages} from 'next-intl';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import HeroSection from '@/content/industry-construction-and-engineering/hero';
import shared from '../messages/en/shared.json';
import industryConstructionEngineering from '../messages/en/industryConstructionEngineering.json';

// Dynamic Content Components import
const FeaturesSection = dynamic(
  () => import('@/content/industry-construction-and-engineering/features-section'),
  {loading: () => null}
);
const SplitFeaturesSection = dynamic(
  () => import('@/content/industry-construction-and-engineering/split-features-section'),
  {loading: () => null}
);
const CustomerStoriesSection = dynamic(
  () => import('@/content/industry-construction-and-engineering/customer-stories-section'),
  {loading: () => null}
);
const FaqSection = dynamic(
  () => import('@/content/industry-construction-and-engineering/faq-section'),
  {loading: () => null}
);
const PrefooterSection = dynamic(
  () => import('@/content/industry-construction-and-engineering/prefooter-section'),
  {loading: () => null}
);

const IndustryConstructionAndEngineeringPage = () => (
  <>
    <HeroSection />
    <FeaturesSection />
    <SplitFeaturesSection />
    <CustomerStoriesSection />
    <FaqSection />
    <PrefooterSection />
  </>
);

type PageMessagesProps = {
  locale: string;
  messages: AbstractIntlMessages;
};

const seoMetas = (props: PageMessagesProps) => {
  const t = createTranslator({
    locale: props.locale,
    messages: props.messages
  }) as (key: string) => string;

  return {
    title: t('industryConstructionEngineering.seo.title'),
    description: t('industryConstructionEngineering.seo.description'),
    canonical: t('industryConstructionEngineering.seo.canonical')
  };
};

export const messagesForIntl = {shared, industryConstructionEngineering};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(IndustryConstructionAndEngineeringPage, seoMetas as never);
